/* eslint-disable no-shadow */
/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is
governed by the Apache 2.0 license. */

import React, {
  ChangeEvent,
  FC,
  useCallback,
  useEffect,
  useState,
} from 'react';
import classNames from 'classnames';
import PhoneInput from 'react-phone-input-2';
import styles from './styles.module.scss';
import { t } from '../../../i18n';
import 'react-phone-input-2/lib/style.css';

interface IProps {
  value: string;
  id: string;
  label?: string;
  placeholder?: string;
  name: string;
  icon: string;
  isSuccess: boolean;
  hasError?: boolean;
  mask?: string;
  handler: (e: ChangeEvent<HTMLInputElement>) => void;
  removeError?: (
    fieldName: string,
    prevValue: string,
    curValue: string
  ) => void;
}

const TextInputWithIcon: FC<IProps> = ({
  value,
  id,
  label,
  name,
  icon,
  hasError,
  placeholder,
  handler,
  mask,
  isSuccess,
  removeError,
}) => {
  const [focused, setFocused] = useState(false);
  const [valuePhone, setValuePhone] = useState('');

  const onChange = (
    value: string,
    country: any,
    e: ChangeEvent<HTMLInputElement>
  ) => {
    if (removeError) {
      removeError(name, value, e.target.value);
    }
    if (e.target) {
      handler(e);
      setValuePhone(value);
    }
  };
  const onFocus = useCallback(() => setFocused(true), [setFocused]);
  const onBlur = useCallback(() => setFocused(false), [setFocused]);

  useEffect(() => {
    if (isSuccess) {
      setValuePhone('+1');
    }
  }, [isSuccess]);

  if (name === 'phone')
    return (
      <div
        className={classNames(styles.phoneInput, {
          [styles.has_error]: hasError,
        })}
      >
        <div className={styles.input__error}>
          {t('cases.restocare.contact.fill_this_field')}
        </div>
        <PhoneInput
          country="us"
          masks={{ am: '.. ... ...', us: '... ... ....' }}
          value={valuePhone}
          onChange={onChange}
          placeholder="+1"
          inputProps={{
            name,
            id,
            onFocus,
            onBlur,
          }}
        />
      </div>
    );

  return (
    <div className={classNames(styles.wrap, { [styles.has_error]: hasError })}>
      <div className={styles.icon}>
        <img src={icon} alt={label} />
      </div>

      <div
        className={classNames(styles.input, {
          [styles.focused]: focused || value,
          [styles.without_label]: !label,
        })}
      >
        {label && (
          <div className={styles.input__label}>
            {t(label)} {mask}
          </div>
        )}

        <div className={styles.input__error}>
          {t('cases.restocare.contact.fill_this_field')}
        </div>

        <input
          id={id}
          type="text"
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={handler}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      </div>
    </div>
  );
};

export { TextInputWithIcon };
